/** Espelha a árvore `(dashboard)/dashboard/...` do guia Next.js em rotas React Router. */
export const DASHBOARD_PATHS = {
  home: "/dashboard",
  instances: "/dashboard/instances",
  instancesNew: "/dashboard/instances/new",
  instance: (id: string) => `/dashboard/instances/${id}`,
  messages: "/dashboard/messages",
  messagesForInstance: (instanceId: string) => `/dashboard/messages/${instanceId}`,
  contacts: "/dashboard/contacts",
  automations: "/dashboard/automations",
  settings: "/dashboard/settings",
} as const;
